import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './admin-module/admin-layout.component';
import { CoreModule } from './core/core.module';

import { FooterModule } from './shared/components/footer/footer.module';
import { SidebarModule } from './shared/components/sidebar/sidebar.module';
import { NavbarModule } from './shared/components/navbar/navbar.module';
import { AuthGuard } from './shared/guards/auth.guard';
import { ToastrModule } from 'ngx-toastr';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginationIntlService } from './services/shared/mat-pagination-intl.service';
import { TranslateService } from '@ngx-translate/core';
import { CompanyProfileBranchAddressComponent } from './shared/components/company-profile-branch-address/company-profile-branch-address.component';
import { CompanyProfileBranchAddressModule } from './shared/components/company-profile-branch-address/company-profile-branch-address.component.module';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    CoreModule,
    FooterModule,
    SidebarModule,
    NavbarModule,
    CompanyProfileBranchAddressModule,
    ToastrModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    LoadingBarHttpClientModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
   
  ],
  providers: [
    AuthGuard,
    {
      provide: MatPaginatorIntl,
      useFactory: (translate) => {
        const service = new MatPaginationIntlService();
        service.injectTranslateService(translate);
        return service;
      },
      deps: [TranslateService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
